export const CONFIG_PARAMETER = {
  COLOR: "color",
  BRIGHTNESS: "brightness",
  LED_EFFECT: "effect",
};
